'use client';
import React from 'react';

interface PriceItem {
  label: string;
  value: string;
  unit: string;
  change: string;
  positive: boolean;
}

const priceData: PriceItem[] = [
  { label: 'Brent Crude', value: '109.21', unit: 'USD/bbl', change: '1.48%', positive: true },
  { label: 'Natural Gas', value: '2.84', unit: 'USD/MMBtu', change: '0.32%', positive: true },
  { label: 'Production Capacity', value: '60,000', unit: 'bbl/day', change: '2.1%', positive: true },
  { label: 'Gasoline', value: '2.95', unit: 'USD/gal', change: '0.87%', positive: true },
  { label: 'Heating Oil', value: '3.12', unit: 'USD/gal', change: '0.15%', positive: false },
];

export default function PriceTicker() {
  return (
    <div className="w-full bg-[#0F0F0F] border-b border-white/10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center gap-0 overflow-x-auto scrollbar-hide">
          {/* Live badge */}
          <div className="flex-shrink-0 pr-6 py-3 border-r border-white/10">
            <span className="font-mono text-[10px] tracking-[0.2em] text-[#CC0000] uppercase flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#CC0000] animate-pulse" />
              Live
            </span>
          </div>

          {priceData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-6 px-6 py-3 border-r border-white/10 flex-shrink-0"
            >
              <div>
                <p className="text-[10px] text-gray-500 uppercase tracking-[0.15em] font-mono mb-0.5">{item.label}</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-white font-extrabold text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>{item.value}</span>
                  <span className="text-gray-500 text-[10px] font-mono">{item.unit}</span>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={item.positive ? 'text-green-400' : 'text-red-400'}
                  aria-hidden="true"
                >
                  {item.positive ? <path d="m18 15-6-6-6 6" /> : <path d="m6 9 6 6 6-6" />}
                </svg>
                <span className={`font-mono text-[11px] font-medium ${item.positive ? 'text-green-400' : 'text-red-400'}`}>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
